import PageWrapper from "../components/wrappers/pageWrappers";

export default function PublicRoute({ children }) {
  return <PageWrapper>{children}</PageWrapper>;
}
